
<div #app id="app" class="authentication-layout {{season}}">
    <section id="content">
		<div class="app-logo">
			<img ngSrc="{{ assetsPath }}/assets/images/logos/logo_aston_ai.png" [width]="200" [height]="47">
		</div>

		<router-outlet></router-outlet>
    </section>
</div>
